import React from 'react';
import MyDatePicker from '../../components/DatePicker/DatePicker';
import { DateWrapper, FilterWrapper,DatePickerWrapper } from './FilterWithDate.styled';
import {
  filter_icon,
  filter_icon_vector,
  reset_icon,
  share_icon,
} from '../SvgIcon/CommonSvgIcons';
import CalendarDatePicker from '../../components/FilterPanelPost/partials/CalendarDatePicker';

const FilterWithDate = ({
  job_id,
  startDate,
  initialStartDate,
  dateHandler,
  formatValue,
  endDate,
  initialEndDate,
  showSave,
  dateSubmit,
  handleReset,
  handleFilter,
  handleShareClick,
  channel = '',
  shareOption=false
}) => {
  console.log(shareOption,"shareOption");
  
  return (
    <FilterWrapper shareOption={shareOption}>
      <DateWrapper>
        <div>
          <div
            style={{
              color: '#2a2929',
            }}
          >

            {
              channel == 'enterprise' ?
                'First Uploaded Date:'
                :
                'First Post Date:'
            }
          </div>

          {/* <MyDatePicker
            width='100px !important'
            dateHandler={dateHandler}
            format={formatValue}
            min={initialStartDate}
            max={initialEndDate}
            // readOnlyvalue={true}
          readOnlyvalue={!job_id ? true : false}
          /> */}
          <DatePickerWrapper>
          <CalendarDatePicker
                width='100px !important'
            name='firstPostDate'
            value={startDate || initialStartDate}
                dateHandler={dateHandler}
                format={formatValue}
                showIcon={true}
                    
                min={initialStartDate ? initialStartDate : ''}
                max={initialEndDate ? initialEndDate  : ''}
                readOnlyvalue={!job_id ? true : false}
              />

          </DatePickerWrapper>
        </div>
        <div>
          <div
            style={{
              color: '#2a2929',
            }}
          >
            {
              channel == 'enterprise' ?
                'Last Uploaded Date:'
                :
                'Last Post Date:'
            }

          </div>

          {/* <MyDatePicker
            width='100px !important'
            name='lastPostDate'
            value={endDate || initialEndDate}
            dateHandler={dateHandler}
            // readOnlyvalue={true}
            readOnlyvalue={!job_id ? true : false}
            format={formatValue}
          /> */}
          
          <DatePickerWrapper>
          <CalendarDatePicker
                width='100px !important'
                name='lastPostDate'
                value={endDate || initialEndDate}
                dateHandler={dateHandler}
                format={formatValue}
                showIcon={true}
                placeholder='DD-MM-YYYY'
                    
                min={startDate ? startDate : ''}
                max={initialEndDate ? initialEndDate  : ''}
              />

          </DatePickerWrapper>
        </div>
        {typeof job_id === 'number' && (showSave ?
          (
            <button className='button' onClick={dateSubmit}>
              Apply
            </button>
          )
          :
          (
            <button className='button' onClick={handleReset}>
              Reset
              {reset_icon}
            </button>
          )
        )
        }
      </DateWrapper>
      <div></div>
      <div className='buttonContainer'>
        <button className='button-custom' onClick={handleFilter}>
          Customize View
          {filter_icon_vector}
        </button>
        {
        (channel != 'enterprise' && typeof job_id === 'number') && (
          <button className='button' onClick={handleShareClick}>
            Share
            {share_icon}
          </button>
        )}
      </div>
    </FilterWrapper>
  );
};

export default FilterWithDate;
